import { ToastContainer } from 'react-toastify';

import { DIALOG_TOAST_CONTAINER } from './dialogToast';

/**
 * Toast outlet placed inside each pop-up, so its errors show above the modal backdrop.
 *
 * @returns {React.ReactElement} The container.
 */
const DialogToaster = () => <ToastContainer enableMultiContainer containerId={DIALOG_TOAST_CONTAINER} />;

export default DialogToaster;
